// DRS Lane Theme JS

document.addEventListener('DOMContentLoaded', () => {

  // ── Mobile Menu ──────────────────────────────────────────────────────────
  const mobileToggle = document.getElementById('mobileMenuToggle');
  const mobileNav = document.getElementById('mobileNav');
  const mobileClose = document.getElementById('mobileNavClose');
  const overlay = document.getElementById('mobileNavOverlay');

  function openMobileNav() {
    mobileNav.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  mobileToggle?.addEventListener('click', openMobileNav);
  mobileClose?.addEventListener('click', closeMobileNav);
  overlay?.addEventListener('click', closeMobileNav);

  // ── Search ───────────────────────────────────────────────────────────────
  const searchToggle = document.getElementById('searchToggle');
  const searchBar = document.getElementById('searchBar');
  const searchClose = document.getElementById('searchClose');

  searchToggle?.addEventListener('click', () => {
    searchBar.classList.toggle('open');
    if (searchBar.classList.contains('open')) {
      searchBar.querySelector('.search-input')?.focus();
    }
  });
  searchClose?.addEventListener('click', () => searchBar.classList.remove('open'));

  // ── Sticky Header ────────────────────────────────────────────────────────
  const header = document.getElementById('site-header');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 60) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }
  });

  // ── Carousels ────────────────────────────────────────────────────────────
  document.querySelectorAll('.carousel-wrap').forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const prevBtn = carousel.querySelector('.carousel-arrow.prev');
    const nextBtn = carousel.querySelector('.carousel-arrow.next');
    if (!track) return;

    let current = 0;
    const cards = track.querySelectorAll('.product-card');
    const visible = () => window.innerWidth > 1100 ? 4 : window.innerWidth > 900 ? 3 : window.innerWidth > 600 ? 2 : 1;
    const max = () => Math.max(0, cards.length - visible());

    function slide() {
      const cardWidth = cards[0]?.offsetWidth + 20;
      track.style.transform = `translateX(-${current * cardWidth}px)`;
    }

    nextBtn?.addEventListener('click', () => { if (current < max()) { current++; slide(); } });
    prevBtn?.addEventListener('click', () => { if (current > 0) { current--; slide(); } });
    window.addEventListener('resize', () => { current = Math.min(current, max()); slide(); });
  });

  // ── Product Gallery ──────────────────────────────────────────────────────
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img')?.src;
      const mainImg = thumb.closest('.product-gallery')?.querySelector('.main-img img');
      if (mainImg && src) {
        mainImg.src = src;
        thumb.closest('.product-thumbs')?.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  // ── Size selector ────────────────────────────────────────────────────────
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.size-options')?.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── Quick Add to Cart ───────────────────────────────────────────────────
  document.querySelectorAll('.product-quick-add').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!res.ok) throw new Error('Add to cart failed');

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartCountEl = document.querySelector('.cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        } else {
          const cartIcon = document.querySelector('.cart-icon');
          if (cartIcon) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartIcon.appendChild(span);
          }
        }

        btn.textContent = 'Added!';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);
      } catch (err) {
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);
      }
    });
  });

  // ── Scroll reveal ────────────────────────────────────────────────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .section-header, .team-item, .driver-num').forEach(el => {
    el.classList.add('fade-up');
    observer.observe(el);
  });

});

// Fade-up animation
const style = document.createElement('style');
style.textContent = `
  .fade-up { opacity: 0; transform: translateY(24px); transition: opacity 0.5s ease, transform 0.5s ease; }
  .fade-up.visible { opacity: 1; transform: translateY(0); }
  .site-header.scrolled { box-shadow: 0 4px 20px rgba(0,0,0,0.4); }
`;
document.head.appendChild(style);